import React, { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  $getSelection,
  $isRangeSelection,
  $createParagraphNode,
  COMMAND_PRIORITY_EDITOR,
  createCommand,
  LexicalCommand,
} from 'lexical';
import {
  $createLayoutContainerNode,
  $isLayoutContainerNode,
  LayoutContainerNode,
} from '../nodes/LayoutContainerNode';
import {
  $createLayoutItemNode,
  $isLayoutItemNode,
  LayoutItemNode,
} from '../nodes/LayoutItemNode';

export const INSERT_LAYOUT_COMMAND: LexicalCommand<string> = createCommand(
  'INSERT_LAYOUT_COMMAND'
);

export function LayoutPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!editor.hasNodes([LayoutContainerNode, LayoutItemNode])) {
      throw new Error(
        'LayoutPlugin: LayoutContainerNode and LayoutItemNode not registered on editor'
      );
    }

    return editor.registerCommand<string>(
      INSERT_LAYOUT_COMMAND,
      (templateColumns: string) => {
        const selection = $getSelection();

        if ($isRangeSelection(selection)) {
          const containerNode = $createLayoutContainerNode(templateColumns);

          // Determine how many columns we need based on the template
          const columnCount = templateColumns.split(' ').length;

          // Create layout items for each column
          for (let i = 0; i < columnCount; i++) {
            const layoutItem = $createLayoutItemNode();
            const paragraph = $createParagraphNode();
            layoutItem.append(paragraph);
            containerNode.append(layoutItem);
          }

          selection.insertNodes([containerNode]);
        }

        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );
  }, [editor]);

  return null;
}
